// Copyright (c) 2017 Deere & Company

import PartialDebit from '../../tcsm/partial-debit/components';

export default {
    component: PartialDebit,
    name: 'PARTIAL_DEBIT',
    path: 'audits/record/partial-debit'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/partial-debit.js